module.exports = __webpack_public_path__ + "img/Menu-05.8d8bb16c.png";